{
 "TERMS_CONDITIONS": "Terms & Conditions",
 "PRIVACY": "Privacy Policy",
 "REVOLUPAY_INFO":"<0>REVOLUPAY EP S.L. Payment Entity authorized and supervised by Central Bank of Spain and registered in the Institutions Register with code 6900. RevoluPAY is a Spanish company wholly owned by <1>REVOLUGROUP CANADA INC</1> <3>(TSX.V = REVO).</3></0>",
 "HELP": "Get Help",
 "LOADING": "Loading...",
 "CANCEL": "CANCEL",
 "CONFIRM": "CONFIRM"
}